namespace('compass.hotel');

compass.require('compass.hotel.HotelSmallImageWidget');
compass.require('compass.hotel.HotelShortInfoWidget');
compass.require('compass.hotel.HotelPromoWidget');

compass.hotel.HotelInfoWidget = compass.defineWidget(function HotelInfoWidget(options) {
	var me = this;
	var $j = jQuery;

	var _settings = options;

	var _grabValues = this.grabValues = function() {
		var jsonValues = {};
		return jsonValues;
	};

	this.validate = function() {
		this.validator.validateAll();
		return this.validator.valid;
	};

	this.destroyWidget = function() {
	};

	/* HOTEL IMAGE */
	var _render = this.render = function(widgetElem) {
		var d = _d;

		// Check if redesign is enabled
		if (compass.isRedesignEnabled()) {
			// Redesign layout
			var cardWrapper = d.div({ className: 'hotelInfoCard redesign' });
			var cardContent = d.div({ className: 'hotelInfoCardContent' });

			var imagesAndPromosHolder = d.div({ className : 'imagesAndPromosHolder', 'ARIA-label' : 'Hotel Image' });
			cardContent.append(imagesAndPromosHolder);
			_hotelSmallImageWidget = new compass.hotel.HotelSmallImageWidget(imagesAndPromosHolder, {
				WUID : "HotelInfoWidget_imageAndPromosWidget_" + me.getWUID(),
				slideCount : 4,
				imgs : _settings.hotel.images,
				promos : _settings.hotel.promotions
			});

			// Add camera overlay and click functionality for redesign
			setTimeout(function() {
				var hotelImg = imagesAndPromosHolder.find('.hotelImg');
				if (hotelImg.length) {
					// Wrap the image in a container
					var imageContainer = d.div({ className: 'imageContainer' });
					hotelImg.wrap(imageContainer);
					
					// Add camera overlay
					var cameraOverlay = d.div({ className: 'cameraOverlay' },
						d.i({ className: 'fa-solid fa-camera' })
					);
					hotelImg.parent().append(cameraOverlay);
					
					// Make the image container clickable to open photos tab
					hotelImg.parent().addClass('clickable').activate(function() {
						// Find and click the Photos tab
						var photosTab = $j('.tab.photosTab');
						if (photosTab.length) {
							photosTab.click();
						}
					});
				}
			}, 100); // Small delay to ensure widget is rendered

			var infoContainer = d.div({ className : 'infoContainer'});

			/*HOTEL NAME, DISTANCE, AVERAGE NIGHTLY RATE */
			var hotelShortInfoHolder = d.div({ className : 'hotelShortInfoHolder' });
				_hotelShortInfoWidget = new compass.hotel.HotelShortInfoWidget(hotelShortInfoHolder, {
					WUID : "HotelInfoWidget_hotelShortInfoWidget_" + me.getWUID(),
					hotel : _settings.hotel,
					meetingInfo: _settings.meetingInfo,
					showZeroRateAsTBD : _settings.showZeroRateAsTBD,
					hideDistance : _settings.hideDistance,
					displayHotelStars: _settings.displayHotelStars,
					displayPriceSavings: _settings.displayPriceSavings
				});
			
			if (_settings.hotel.avail.affiliates && _settings.hotel.avail.affiliates.indexOf('EAN') != -1) {
				_hotelShortInfoWidget.find('.averageNightlyRate').hide();
				_hotelShortInfoWidget.find('.averageNightlyRateText').hide();
			}

			infoContainer.append(hotelShortInfoHolder);

			if (_settings.hotel.avail.status !== 'GDS') {
				infoContainer.append(_drawhotelPolicyLink());
			}

			if (_settings.hotel.avail.affiliates && (_settings.hotel.avail.affiliates.indexOf("EAN") !== -1 ) ) {
				infoContainer.append(_drawhotelPolicyLink());
			}

			cardContent.append(infoContainer);

			var drawShowHidePromoLink = false;

			if(_settings.showPromos) {
				/*PROMOTIONS */
				var hotelPromoHolder = d.div({ className : 'hotelPromoHolder' });
				var _hotelPromoWidget = new compass.hotel.HotelPromoWidget(hotelPromoHolder, {
						WUID : 'HotelInfoWidget_HotelPromoWidget' +  me.getWUID(),
						promos : _settings.hotel.promotions,
						amenities : _settings.hotel.amenities,
						currencySymbol : _settings.meetingInfo.currencySymbol,
						hideHotelExtras: _settings.hotel.hotelInfo.showEPSHotelInfo === 'Y' ? true : false,
						defaultPromotions : _settings.hotel.defaultPromotions
					});

				// Create and insert an offscreen div so we can figure out the height of the promos
				var offscreenDiv = d.div({
					style:{
						'visibility': 'hidden',
						'position' : 'absolute',
						'left' : "-9999999px",
						'width': '185px',
						'max-height': '193px'
					}
				}, hotelPromoHolder);

				$(document.body).append(offscreenDiv);

				if (hotelPromoHolder.height() > offscreenDiv.height()) {
					drawShowHidePromoLink = true;
				}

				offscreenDiv.remove();

				cardContent.append(hotelPromoHolder);
			}

			if (drawShowHidePromoLink) {
				_hotelPromoWidget.getWidgetElem().addClass('expandable');
				var showHideText = d.div({className:'showHideText'},
					d.a({href:'javascript:;', className:"showHideTextLink"}, 
						"Show More"
					).activate(function(){
						_hotelPromoWidget.getWidgetElem().toggleClass( "open" );
						if (_hotelPromoWidget.getWidgetElem().hasClass('open')) {
							showHideText.find('.showHideTextLink').text('Show Less');
						} else {
							showHideText.find('.showHideTextLink').text('Show More');
							// On hide we should scroll the window to the top of the promos
							$('html, body').animate({
								scrollTop: (_hotelPromoWidget.getWidgetElem().offset().top - 16)
							}, 200);
						}
					})
				);

				hotelPromoHolder.append(showHideText);
			}

			if(_settings.meetingInfo.hotelInfoCustomText && _settings.hotel.avail.status !== 'GDS') {
				//Check if hotelpromo is empty and hide - prevents double border-top
				if(cardContent.find('.HotelPromoWidget').contents().length === 0) {
					cardContent.find('.hotelPromoHolder').hide();
				}
				var hotelInfoCustomText = d.div({ className : 'hotelInfoCustomText' }, _settings.meetingInfo.hotelInfoCustomText);
				cardContent.append( d.div({ className : 'hotelInfoCustomTextHolder' }, hotelInfoCustomText));
			}
			
			cardWrapper.append(cardContent);
			widgetElem.append(cardWrapper);
		} else {
			// Original layout - completely preserve legacy behavior
			var imagesAndPromosHolder = d.div({ className : 'imagesAndPromosHolder', 'ARIA-label' : 'Hotel Image' });
			widgetElem.append(imagesAndPromosHolder);
			_hotelSmallImageWidget = new compass.hotel.HotelSmallImageWidget(imagesAndPromosHolder, {
				WUID : "HotelInfoWidget_imageAndPromosWidget_" + me.getWUID(),
				slideCount : 4,
				imgs : _settings.hotel.images,
				promos : _settings.hotel.promotions
			});

			var infoContainer = d.div({ className : 'infoContainer'});

			/*HOTEL NAME, DISTANCE, AVERAGE NIGHTLY RATE */
			var hotelShortInfoHolder = d.div({ className : 'hotelShortInfoHolder' });
				_hotelShortInfoWidget = new compass.hotel.HotelShortInfoWidget(hotelShortInfoHolder, {
					WUID : "HotelInfoWidget_hotelShortInfoWidget_" + me.getWUID(),
					hotel : _settings.hotel,
					meetingInfo: _settings.meetingInfo,
					showZeroRateAsTBD : _settings.showZeroRateAsTBD,
					hideDistance : _settings.hideDistance,
					displayHotelStars: _settings.displayHotelStars,
					displayPriceSavings: _settings.displayPriceSavings
				});
			
			if (_settings.hotel.avail.affiliates && _settings.hotel.avail.affiliates.indexOf('EAN') != -1) {
				_hotelShortInfoWidget.find('.averageNightlyRate').hide();
				_hotelShortInfoWidget.find('.averageNightlyRateText').hide();
			}

			infoContainer.append(hotelShortInfoHolder);

			if (_settings.hotel.avail.status !== 'GDS') {
				infoContainer.append(_drawhotelPolicyLink());
			}

			if (_settings.hotel.avail.affiliates && (_settings.hotel.avail.affiliates.indexOf("EAN") !== -1 ) ) {
				infoContainer.append(_drawhotelPolicyLink());
			}

			widgetElem.append(infoContainer);

			var drawShowHidePromoLink = false;

			if(_settings.showPromos) {
				/*PROMOTIONS */
				var hotelPromoHolder = d.div({ className : 'hotelPromoHolder' });
				var _hotelPromoWidget = new compass.hotel.HotelPromoWidget(hotelPromoHolder, {
						WUID : 'HotelInfoWidget_HotelPromoWidget' +  me.getWUID(),
						promos : _settings.hotel.promotions,
						amenities : _settings.hotel.amenities,
						currencySymbol : _settings.meetingInfo.currencySymbol,
						hideHotelExtras: _settings.hotel.hotelInfo.showEPSHotelInfo === 'Y' ? true : false,
						defaultPromotions : _settings.hotel.defaultPromotions
					});

				// Create and insert an offscreen div so we can figure out the height of the promos
				var offscreenDiv = d.div({
					style:{
						'visibility': 'hidden',
						'position' : 'absolute',
						'left' : "-9999999px",
						'width': '185px',
						'max-height': '193px'
					}
				}, hotelPromoHolder);

				$(document.body).append(offscreenDiv);

				if (hotelPromoHolder.height() > offscreenDiv.height()) {
					drawShowHidePromoLink = true;
				}

				offscreenDiv.remove();

				widgetElem.append(hotelPromoHolder);
			}

			if (drawShowHidePromoLink) {
				_hotelPromoWidget.getWidgetElem().addClass('expandable');
				var showHideText = d.div({className:'showHideText'},
					d.a({href:'javascript:;', className:"showHideTextLink"}, 
						"Show More"
					).activate(function(){
						_hotelPromoWidget.getWidgetElem().toggleClass( "open" );
						if (_hotelPromoWidget.getWidgetElem().hasClass('open')) {
							showHideText.find('.showHideTextLink').text('Show Less');
						} else {
							showHideText.find('.showHideTextLink').text('Show More');
							// On hide we should scroll the window to the top of the promos
							$('html, body').animate({
								scrollTop: (_hotelPromoWidget.getWidgetElem().offset().top - 16)
							}, 200);
						}
					})
				);

				hotelPromoHolder.append(showHideText);
			}

			if(_settings.meetingInfo.hotelInfoCustomText && _settings.hotel.avail.status !== 'GDS') {
				//Check if hotelpromo is empty and hide - prevents double border-top
				if(widgetElem.find('.HotelPromoWidget').contents().length === 0) {
					widgetElem.find('.hotelPromoHolder').hide();
				}
				var hotelInfoCustomText = d.div({ className : 'hotelInfoCustomText' }, _settings.meetingInfo.hotelInfoCustomText);
				widgetElem.append( d.div({ className : 'hotelInfoCustomTextHolder' }, hotelInfoCustomText));
			}
		}
	};


	var _drawhotelPolicyLink = function() {
		var hotelPolicies = _d.div({className: 'hotelPoliciesContainer'},
			_d.a({className: 'hotelPolicies'}, 'View hotel policies &raquo;').activate(function() {
				var blocked_room_ids = [];

				_.each(_settings.hotel.roomTypes, function(roomType) {
					blocked_room_ids.push(roomType.blockedRoomId);
				});

				me.trigger('HotelInfoWidget.showPolicies', {
					blockRoomIds: blocked_room_ids
				});
			})
		);

		return hotelPolicies;
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'HotelInfoWidget',
	imgPath : '/resources/img',
	imgs : [],
	promos : [],
	displayHotelStars : true,
	showZeroRateAsTBD : false,
	showPromos : true,
	displayPriceSavings: true
});

